import { render, staticRenderFns } from "./importrejectlist.vue?vue&type=template&id=61041b59"
import script from "./importrejectlist.vue?vue&type=script&lang=ts"
export * from "./importrejectlist.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports